import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

function CustomizedDialogs(props, ref) {
  var selectedCourse = localStorage.getItem('etlSelectCourse');
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  const [open, setOpen] = React.useState(false);
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function upgradeNow(){
		if(mySelectedCourses && selectedCourse>-1){
			window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
		}
	}

  return (
    <>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>
          <span style={{color:'#FF0000'}}>Alert</span>
        </DialogTitle>

        <DialogContent dividers>
            <div className="dialogSubmitTestBox">              
              <>
              <p>
                You have reached maximum limit in your current package. Kindly upgrade to access the content.
                <br/><br/>               
              </p>
              <Button onClick={() => {upgradeNow()}} style={{marginRight:20}} size="small" variant="contained" color='primary' >Upgrade to ACE</Button>
              </>
              
            </div>
        </DialogContent>

      </Dialog>
    </>
  );
}

export default React.forwardRef(CustomizedDialogs);
